import type { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { ResponseError } from '@backstage/errors';
import type { SpogReportV0Wire } from '@internal/plugin-spog-common';
import type { SpogApi } from './types';

export class SpogClient implements SpogApi {
  constructor(
    private readonly deps: {
      discoveryApi: DiscoveryApi;
      fetchApi: FetchApi;
    },
  ) {}

  async getReport(runId: string): Promise<SpogReportV0Wire> {
    const baseUrl = await this.deps.discoveryApi.getBaseUrl('spog');
    const res = await this.deps.fetchApi.fetch(
      `${baseUrl}/report/${encodeURIComponent(runId)}`,
    );
    if (!res.ok) {
      throw await ResponseError.fromResponse(res);
    }
    return (await res.json()) as SpogReportV0Wire;
  }
}
